/**
 * ヘッダースクロールアニメーション (header-scroll.js)
 * ・告知バーの高さを考慮してヘッダー位置を調整
 * ・スクロールダウンで隠し、スクロールアップで表示する（Sticky on scroll up）
 */

class HeaderScroll {
  constructor() {
    this.header = document.querySelector('.header-wrapper');
    // IDまたはクラスで告知バーのセクションを探す
    this.announcementSection = document.getElementById('shopify-section-announcement-bar') || document.querySelector('.announcement-bar-section');
    
    this.scrollThreshold = 20; // 色が変わる開始地点
    this.lastScrollTop = 0;    // 前回のスクロール位置を記憶
    
    this.init();
  }

  init() {
    if (!this.header) return;

    // 初期化時とリサイズ時に位置調整を実行
    this.updatePosition();
    this.checkScroll();

    window.addEventListener('resize', () => {
      this.updatePosition();
      this.checkScroll();
    }, { passive: true });

    window.addEventListener('scroll', () => {
      this.handleScroll();
    }, { passive: true });
    
    // 画像読み込み完了後など高さが変わる可能性があるため、少し遅延しても実行
    setTimeout(() => this.updatePosition(), 500);
  }

  // 告知バーの高さ分、ヘッダーを下げる（初期位置）
  updatePosition() {
    // header-transparentクラスがないページは何もしない
    if (!document.body.classList.contains('header-transparent')) return;

    // スクロール済みの場合は更新しない（top: 0 等で制御するため）
    if (this.header.classList.contains('scrolled')) return;

    let offset = 0;
    
    if (this.announcementSection) {
      // 告知バー要素自体の高さを取得
      const bar = this.announcementSection.querySelector('.announcement-bar');
      if (bar) {
        offset = bar.offsetHeight;
      } else {
        offset = this.announcementSection.offsetHeight;
      }
    }

    // ヘッダーのtop位置を更新
    this.header.style.top = `${offset}px`;
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.checkScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  checkScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isScrolled = scrollTop > this.scrollThreshold;

    // 1. 背景色変更（scrolledクラス）の制御
    if (isScrolled) {
      this.header.classList.add('scrolled');
    } else {
      this.header.classList.remove('scrolled');
      // 最上部に戻ったら、また告知バーの下に戻す
      this.updatePosition();
    }

    // 2. 出し分け（隠す/表示）の制御
    // スクロール量が閾値を超えている場合のみ判定
    if (scrollTop > this.scrollThreshold) {
      if (scrollTop > this.lastScrollTop) {
        // 下にスクロール中 -> 隠す
        this.header.classList.add('header-hidden');
      } else {
        // 上にスクロール中 -> 表示する
        this.header.classList.remove('header-hidden');
        
        // 白背景時はtop:0に固定
        if (document.body.classList.contains('header-transparent')) {
          this.header.style.top = '0px';
        }
      }
    } else {
      // 最上部付近では常に表示
      this.header.classList.remove('header-hidden');
    }

    // 現在のスクロール位置を保存（次回比較用）
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
  }
}

// 読み込み完了時に実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HeaderScroll());
} else {
  new HeaderScroll();
}